module.exports = __webpack_public_path__ + "static/media/ducted-furnace.4cedb943.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ducted-furnace.png
// module id = 156
// module chunks = 0